<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <vendor_list_table :vendors="content" />
        </div>

        <pagination :allData="vendorsData" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import vendor_list_table from '@/components/application/vendors/vendor_list/vendor_list_table.vue';
import Vendors from '@/data/vendors.json';
import pagination from '@/layouts/elements/pagination.vue';
import { useFunctionalitiesStore } from '@/store/functionalities';
import { storeToRefs } from 'pinia';

const functionalitiesStore = useFunctionalitiesStore();
const { state } = storeToRefs(functionalitiesStore);
const vendorsData = ref(Vendors.data);

const content = computed(() => state.value.content);
</script>

<style></style>
